/**
 * These functions control loading and opening of a Mopinion feedback widget.
 * We use this because we do not want to load the Mopinion script on each page load.
 */

import initData from 'init-data';
import GdprSettings from 'tradera-utils/gdpr-settings';
const mopinionDeploymentId = 'wn05g86aghlgi91ctabv3m29illmqf7nfx4';

export const messagingFeedbackForm = '6f7ae9cf201115236e162e097ef108046c2cb431';
export const generalFeedbackForm = '06b06d1a56fda2f980b754939a1b4c1389bd9c2b';
export const languageFeedbackForm = 'b418052da5fb4f4dfb3acb004b7519d12df8f49e';

/**
 * Returns true if Mopinion widgets is enabled.
 */
export const isEnabled = () => {
    return (
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches['mopinion-feedback-widgets'] &&
        GdprSettings.isFunctionalEnabled()
    );
};

/**
 * Returns true if Mopinion widgets is enabled.
 */
const isMemberDataEnabled = () => {
    return (
        initData &&
        initData.featureSwitches &&
        initData.featureSwitches['mopinion-member-data']
    );
};

/**
 * Adds the Mopinion script to the page.
 */
const addScriptToDom = () => {
    if (!isEnabled()) {
        return;
    }
    const dataAttributeName = 'data-mopinion-script';
    if (document.querySelector(`[${dataAttributeName}]`)) {
        return;
    }
    const js = document.createElement('script');
    js.setAttribute(dataAttributeName, '1');
    js.setAttribute('type', 'text/javascript');
    js.setAttribute('src', '//deploy.mopinion.com/js/pastease.js');
    document.getElementsByTagName('head')[0].appendChild(js);
    loadMopinionWidget();
};

/**
 * Loads the Mopinion survey with the given ID.
 * @param {String} memberId The currently logged in member
 * @param {String} mopinionDeploymentId The ID of the Mopinion survey
 */
const loadMopinionWidget = () => {
    if (!isEnabled()) {
        return;
    }
    let attemptsLeft = 100;
    const timeBetweenAttempts = 50;
    const t = setInterval(function() {
        if (window.Pastease) {
            new window.Pastease.load(mopinionDeploymentId);
            clearInterval(t);
        } else if (--attemptsLeft < 1) {
            clearInterval(t);
        }
    }, timeBetweenAttempts);
};

/**
 * Opens the Mopinion widget that is currently loaded.
 */
export const openMopinionWidget = formKey => {
    if (!isEnabled()) {
        return;
    }
    addScriptToDom();
    let attemptsLeft = 100;
    const timeBetweenAttempts = 50;
    const t = setInterval(function() {
        if (window.srv) {
            if (isMemberDataEnabled()) {
                const { memberId, memberEmail } = initData;
                window.memberId = memberId;
                window.memberEmail = memberEmail;
            }
            setTimeout(() => {
                window.srv.openModal(true, formKey);
            }, 100);
            clearInterval(t);
        } else if (--attemptsLeft < 1) {
            clearInterval(t);
        }
    }, timeBetweenAttempts);
};
